import { withViewModel } from '@hooks/useViewModel';
import useBPDOAuthLogin from '~/sections/login/useBPDOAuthLogin';
import LogIn from '~/sections/login/LogIn';

const LogInContainer = withViewModel(LogIn, useBPDOAuthLogin);

export default LogInContainer;
